import { createStyles, makeStyles, Theme, fade } from '@material-ui/core/styles';

import { MIDDLE_MARGIN, colorsPalette, SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles(
  (theme: Theme) =>
    createStyles({
      wrapper: {
        marginBottom: SMALL_MARGIN,
        [theme.breakpoints.up('md')]: {
          borderBottom: `3px solid ${fade(colorsPalette.violet, 0.3)}`,
          marginBottom: SMALL_MARGIN / 2,
        },
      },
      titleBlock: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: SMALL_MARGIN,
      },
      backBtn: {
        background: 'transparent',
        border: 'none',
        padding: 4,
        marginRight: SMALL_MARGIN / 2,
        cursor: 'pointer',
        [theme.breakpoints.up('md')]: {
          marginRight: SMALL_MARGIN,
        },
      },
      backIcon: {
        width: 20,
        height: 20,
      },
      title: {
        lineHeight: 1.2,
        fontSize: 18,
        marginBottom: 5,
        color: colorsPalette.white,
        [theme.breakpoints.up('md')]: {
          fontSize: 20,
        },
      },
      description: {
        lineHeight: 1.5,
        fontSize: 18,
        marginBottom: SMALL_MARGIN,
        [theme.breakpoints.up('md')]: {
          fontSize: 20,
          marginBottom: MIDDLE_MARGIN,
        },
      },
      exportBlock: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginBottom: SMALL_MARGIN,
        [theme.breakpoints.up('md')]: {
          paddingTop: SMALL_MARGIN,
        },
      },
    }),
  {
    name: 'TableViewHeader',
  },
);

export default useStyles;
